<template>
    <b-table class="target-builds-platforms-table" :data="platforms" ref="table" :mobile-cards="false"
             hoverable striped bordered v-bind="$attrs" v-on="$listeners" sticky-header height="80vh">
        <template #empty>
            <b><slot name="empty-message">No results found</slot></b>
        </template>

        <b-table-column v-slot="props" field="target" label="Target" width="100"
                        sticky class="test-cases-table-test-column">
                <span :title="props.row.id">{{ props.row.name }}</span>
            </b-table-column>

        <template v-for="targetBuild in targetBuilds">
            <b-table-column :label="targetBuild.target" :custom-key="targetBuild.id" :key="targetBuild.id">
                <template v-slot:header="{ column }">
                    <CiServiceIcon :ci-service="targetBuild.ci_service"/>
                    <BuildTriggerTypeIcon :type="targetBuild.build_type_id"/>
                    <span class="tooltip-target test-run-id"
                          :title="targetBuild.target"
                          @click="$emit('select-target-build', targetBuild.id)">
                        {{ column.label }}
                    </span>
                </template>
                <template v-slot="props">
                    <div class="test-result-container">
                        <div v-for="testResult in getTestResults(props.row.id, targetBuild.id)"
                             :key="testResult.id" class="test-summary-result-container">
                            <b>{{ testResult.mtr_name }}</b>
                            <router-link :to="generateResultsLink(props.row.id, targetBuild.target, testResult.mtr_id)">
                                <test-summary-result :test-result="testResult"/>
                            </router-link>
                        </div>
                    </div>
                </template>
            </b-table-column>
        </template>
    </b-table>
</template>

<script>
    import TestSummaryResult from "./TestSummaryResult";
    import CiServiceIcon from "@/components/CiServiceIcon";
    import BuildTriggerTypeIcon from "@/components/BuildTriggerTypeIcon";

    export default {
        name: "TargetBuildsPlatformsTable",
        props: {
            platforms: Array,
            testResults: Array,
            targetBuilds: Array,
            linkGenerator: Function,
        },
        data() {
            return {
                currentTestResult: null,
                isTestResultModalActive: false,
            }
        },
        methods: {
            getTestResults(platformId, targetBuildId) {
                return this.testResults.filter(item => {
                    return item.target_build_id === targetBuildId && item.platform_id === platformId && item.count_all !== 0;
                });
            },
            onSelectTestResult(platformId, targetBuildId) {
                this.$emit('select-test-result', { platformId, targetBuildId });
            },
            generateResultsLink(platformId, targetName, mtrId) {
                if (this.linkGenerator == null) return '#';
                return this.linkGenerator(platformId, targetName, mtrId);
            }
        },
        components: {
            TestSummaryResult,
            CiServiceIcon,
            BuildTriggerTypeIcon,
        },
    }
</script>

<style lang="scss" scoped>
    .test-cases-table-test-column {
        max-width: 400px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .test-run-id {
        font-weight: bold;
        cursor: pointer;
        font-size: 0.75em;
        &:hover {
            text-decoration: underline;
        }
    }
    .test-run-name {
        font-weight: normal;
        font-size: 0.75em;
    }

    .target-builds-platforms-table {
        margin-bottom: 20px;
    }

    .test-summary-result-container {
        display: flex;
        flex-direction: column !important;
        margin-bottom: 1em;
        align-items: flex-start;
        justify-content: flex-start;

        & > div {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: row;
            &:hover, &:focus, &:active {
                background-color: $grey-lightest;
            }
        }
    }
</style>